import React, { useState, useEffect } from 'react';
import CheckmarkSVG from "../../assets/Checkmark"; 
import './ProgressBar.css'; 
import { useMediaQuery } from 'react-responsive';

import { useStepContext } from '../../utils/StepContext';

export default function ProgressBar({ currentPage, subStepProgress = 0 }) { 
    const { stepCompletionStatus, setCurrentStep, setSubStepProgress, markStepAsComplete, unsetStepAsComplete, currentStep } = useStepContext();
    const [dropdownVisible, setDropdownVisible] = useState(Array(4).fill(false)); // Assuming there are 4 main steps
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    
    const steps = [
        { 
            label: "PARTIES & PROPERTY", 
            step: 0,
            subSteps: [
                { label: "Buyer Name", component: "NameCard.jsx" }, 
                { label: "Seller Information", component: "SellersCard.jsx"},
                { label: "Addtl Tenants", component: "TenantsCard.jsx" }, 
                // { label: "Water Rights", component: "WaterRights.jsx" }
                {label: "Inclusions One", component: "PreStepMiscellaneous.jsx"},
                { label: "Inclusions Two", component: "Miscellaneous.jsx"}
            ] 
        },
        { 
            label: "DATES & PRICE", 
            step: 1,
            subSteps: [
                { label: "Dates & Deadlines", component: "DatesDeadlines.jsx" }, 
                { label: "Purchase Price", component: "PriceTerms.jsx" }, 
                { label: "Additional Pricing", component: "PriceTerms2.jsx" }
            ]
        },
        { 
            label: "PROVISIONS", 
            step: 2,
            subSteps: [
                { label: "Title", component: "Title.jsx" }, 
                { label: "ILC or Survey", component: "IlcSurvey.jsx" }, 
                { label: "Due Diligence", component: "DisclosureInspection.jsx" },
                { label: "Closing Costs", component: "ClosingCosts.jsx" }, 
                { label: "Prorations", component: "Prorations.jsx" }, 
                { label: "Possession", component: "Possession.jsx" },
                { label: "Provisions", component: "AdditionalProvisions.jsx" },
            ]
        },
        { 
            label: "REVIEW & SIGN", 
            step: 3, 
            subSteps: [
                { label: "Final Review", component: "FinalReview.jsx" }
            ] 
        },
    ]; 

    const getComponentIndex = (label) => {
        const mapping = {
            "Buyer Name": 2,
            "Seller Information": 3,
            "Addtl Tenants": 4,
            "Inclusions One": 5,
            // "Water Rights": 5,
            "Inclusions Two": 6,
            "Dates & Deadlines": 7,
            "Purchase Price": 8,
            "Additional Pricing": 9,
            "Title": 10,
            "ILC or Survey": 11, 
            "Due Diligence": 12, 
            "Closing Costs": 13, 
            "Prorations": 14,
            "Possession": 15, 
            "Provisions": 16, 
            "Final Review": 17, 
        };
    
        return mapping[label] || 0; // Default to 0 or some other fallback
    };

    const handleSubStepSelection = (label) => {
        const index = getComponentIndex(label);
        setCurrentStep(index);
    };    

    // Ensure that marking as complete based on subStepProgress
    useEffect(() => {
        if (currentStep > 5 && currentStep < 9) {
            markStepAsComplete(steps[0].step);
            unsetStepAsComplete(steps[1].step); 
            unsetStepAsComplete(steps[2].step); 
        } else if (currentStep > 8 && currentStep < 16 ) {
            markStepAsComplete(steps[1].step);
            markStepAsComplete(steps[0].step); 
            unsetStepAsComplete(steps[2].step);
        } else if (currentStep > 15) {
            markStepAsComplete(steps[0].step);
            markStepAsComplete(steps[1].step);
            markStepAsComplete(steps[2].step); 
        } else {
            unsetStepAsComplete(steps[0].step);
            unsetStepAsComplete(steps[1].step);
            unsetStepAsComplete(steps[2].step);
        }
    }, [subStepProgress, currentStep]);

    return (
        <div className="w-full flex justify-center py-2">
            <div className="progress-container">
                {steps.map((item, index, array) => (
                    <React.Fragment key={index}>
                        <div 
                            className="progress-step-container"
                            onMouseEnter={() => setDropdownVisible(prev => ({...prev, [index]: true}))}
                            onMouseLeave={() => setDropdownVisible(prev => ({...prev, [index]: false}))}
                        >
                            <div className="progress-step">
                                <span className="step-text">{item.label}</span>
                                <button
                                    className={`step-button ${currentPage === item.step ? 'active' : currentPage > item.step ? 'completed' : ''}`}>
                                    {currentPage > item.step && <CheckmarkSVG />}
                                </button>
                            </div>
                            {dropdownVisible[index] && (
                                <div className="substeps-dropdown">
                                    {item.subSteps.map((subStep) => (
                                        <div key={subStep.label} onClick={() => handleSubStepSelection(subStep.label)} className="substep-item">
                                            {subStep.label}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {index < array.length - 1 && (
                            <div 
                                className={`step-line ${currentPage === item.step ? 'active' : ''}`} 
                                style={{
                                    background: getLineStyle(index, currentPage, subStepProgress, stepCompletionStatus)
                                }}>
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    ); 
}

function getLineStyle(index, currentPage, subStepProgress, stepCompletionStatus) {
    // Check if the current step is completely finished
    if (stepCompletionStatus[index]) {
        return '#004225'; // Step is completely finished
    } else if (currentPage === index) {
        // Current step in progress
        return subStepProgress >= 1 ?
            '#004225' :
            `linear-gradient(to left, #DDD, #DDD ${100 - subStepProgress * 100}%, #004225 ${100 - subStepProgress * 100 + 40}%, #004225)`;
    } else {
        return '#DDD'; // Not yet started
    }
}